function qsToString(qs: URLSearchParams) {
  return qs.toString().replace(/%2C/g, ",");
}

export function getParam(name: string): string | null {
  const qs = new URLSearchParams(name);
  return qs.get(name);
}

export function getNumbersParam(name: string): number[] {
  const qs = new URLSearchParams(window.location.search);
  const strValue = qs.get(name);
  if (!strValue) return [];
  return JSON.parse(`[${strValue}]`);
}

export function setParam(name: string, value: string) {
  const qs = new URLSearchParams(window.location.search);
  qs.set(name, value);
  const newQuery = qsToString(qs);
  const newUrl = `${window.location.pathname}${newQuery ? "?" + newQuery : ""}${
    window.location.hash
  }`;
  window.history.pushState(null, "", newUrl);
}

export function setNumbersParam(name: string, values: number[]) {
  const qs = new URLSearchParams(window.location.search);
  qs.set(name, values.join(","));
  const newQuery = qsToString(qs);
  const newUrl = `${window.location.pathname}${newQuery ? "?" + newQuery : ""}${
    window.location.hash
  }`;
  window.history.pushState(null, "", newUrl);
}

export function removeParams(names: string[]) {
  const qs = new URLSearchParams(window.location.search);
  for (const name of names) {
    qs.delete(name);
  }
  const newQuery = qsToString(qs);
  const newUrl = `${window.location.pathname}${newQuery ? "?" + newQuery : ""}${
    window.location.hash
  }`;
  window.history.pushState(null, "", newUrl);
}
